/**
 * [INPUT]: 依赖真实 HTTP AdminApi 适配器与局域网 API 配置
 * [OUTPUT]: 对外提供页面唯一使用的 adminApi 实例
 * [POS]: admin-web composition root，所有环境统一连接真实 server
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */
import type { AdminApi } from './admin-api';
import { httpAdminApi } from './http-api';

export const adminApi: AdminApi = httpAdminApi;
